import { render, staticRenderFns } from "./EUserRole.vue?vue&type=template&id=99cecf46"
import script from "./EUserRole.vue?vue&type=script&lang=js"
export * from "./EUserRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports